const tokenToString = (token) => token.value

export default tokenToString
